import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const UpArrowIcon = observer('UpArrowIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='#061A32'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
            onClick={onClick}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M2 12L12 2L22 12L20.1871 13.7544L13.228 6.79529V22H10.7719V6.79529L3.75432 13.7544L2 12Z'
                fill='fill'
            />
        </SvgElement>
    );
});
